define("settings/templates/groups/group/edit", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{action (perform this.handleClose this.group)}} as |modal|>
    <modal.card @portrait={{true}}>
      <modal.card-header @title={{t "account.groups.group.edit.title"}} />
      <ModalForm @cancel={{modal.close}} @task={{task this.handleSubmit this.group}} as |form|>
        <modal.card-body>
          <div class="o--user--lg">
            <AvatarUpload @addDataUrl={{action this.addDataUrl this.group}} @defaultUrl={{this.group.imageUrl}} />
            <form.input
              @autofocus={{true}}
              @placeholder={{t "account.groups.group.edit.name_placeholder"}}
              @value={{this.group.name}}
              @wrapperClass="u--m__t__xs"
            />
          </div>
        </modal.card-body>
        <modal.card-footer>
          <form.footer @submitButtonText={{t "shared_words.save"}} />
        </modal.card-footer>
      </ModalForm>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "sN7QBkaK",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[28,[37,1],[[30,0],[28,[37,2],[[30,0,[\"handleClose\"]],[30,0,[\"group\"]]],null]],null]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card-header\"]],null,[[\"@title\"],[[28,[37,3],[\"account.groups.group.edit.title\"],null]]],null],[1,\"\\n    \"],[8,[39,4],null,[[\"@cancel\",\"@task\"],[[30,1,[\"close\"]],[28,[37,5],[[30,0,[\"handleSubmit\"]],[30,0,[\"group\"]]],null]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[10,0],[14,0,\"o--user--lg\"],[12],[1,\"\\n          \"],[8,[39,6],null,[[\"@addDataUrl\",\"@defaultUrl\"],[[28,[37,1],[[30,0],[30,0,[\"addDataUrl\"]],[30,0,[\"group\"]]],null],[30,0,[\"group\",\"imageUrl\"]]]],null],[1,\"\\n          \"],[8,[30,2,[\"input\"]],null,[[\"@autofocus\",\"@placeholder\",\"@value\",\"@wrapperClass\"],[true,[28,[37,3],[\"account.groups.group.edit.name_placeholder\"],null],[30,0,[\"group\",\"name\"]],\"u--m__t__xs\"]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,2,[\"footer\"]],null,[[\"@submitButtonText\"],[[28,[37,3],[\"shared_words.save\"],null]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[2]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"modal\",\"form\"],false,[\"shared/modal\",\"action\",\"perform\",\"t\",\"modal-form\",\"task\",\"avatar-upload\"]]",
    "moduleName": "settings/templates/groups/group/edit.hbs",
    "isStrictMode": false
  });
});